/**
 * GluestackUI Provider
 * Wraps the app with Gluestack UI theme configuration and color mode support.
 * Only handles theming — no layout, no testIDs.
 */

import React from 'react';
import { GluestackUIProvider as Provider } from '@gluestack-ui/themed';
import { config } from '../../../gluestack-ui.config';
import { useColorMode, ColorModeProvider, type ColorModePreference } from '../../contexts/ColorModeContext';

interface GluestackUIProviderProps {
  children: React.ReactNode;
  /** Force initial color mode (used by Storybook) */
  initialColorMode?: ColorModePreference;
}

function GluestackUIProviderInner({ children }: { children: React.ReactNode }) {
  const { effectiveColorMode } = useColorMode();

  return (
    <Provider config={config} colorMode={effectiveColorMode}>
      {children}
    </Provider>
  );
}

export function GluestackUIProvider({ children, initialColorMode }: GluestackUIProviderProps) {
  return (
    <ColorModeProvider initialMode={initialColorMode}>
      <GluestackUIProviderInner>{children}</GluestackUIProviderInner>
    </ColorModeProvider>
  );
}
